import { GetterTree } from 'vuex';
import { EventLogState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<EventLogState, RootState> = {
  ['getEventLogAllEntries']: (state) => state.allLogEntries,
  ['getEventLogFilteredEntries']: (state) => state.filteredLogEntries,
  ['getEventLogCurrentPageEntries']: (state) => state.currentPageLogEntries,
  ['getEventLogIsLoading']: (state) => state.isLoading,
  ['getEventLogTotal']: (state) => state.filteredLogEntries.length,
  ['getEventLogSearchParams']: (state) => state.searchParams,
};
